import { Injectable } from '@angular/core';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';

import { HttpClient } from '@angular/common/http';

import { HttpHelperService } from 'src/app/core/services/http-helper.service';

import { LsHelperService } from 'src/app/core/services/ls-helper.service';

@Injectable({
	providedIn: 'root'
})
export class AccountService extends BaseProvider {
	roles: any = [];
	showManagement = false;
	itemToEdit: any = {};
	fileToLoad: any;

	profiles: any = [];
	menu: any = [];
	selectedProfile: any = null;
	selectedMenu: any = null;
	constructor(
		public globals: GlobalsService,
		private httpHelper: HttpHelperService,
		public http: HttpClient,
		public ls: LsHelperService,
	) {
		super();

		this.baseUrl = 'userProfile';
	}

	getById(id) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/' + id;

			const loginData = this.ls.get('loginData');

			this.http.get(
				this.url
			)
				.subscribe(
					(data: any) => {
						this.itemToEdit = data.Data;

						resolve(this.itemToEdit);
					},
					err => { reject(err); }
				);
		});
	}

	getRoles() {
		return new Promise((resolve, reject) => {
			if (this.roles.length > 0) { resolve(this.roles); }

			this.url = this.globals.dataUrl + this.baseUrl + '/roles';

			this.http
				.get(this.url)
				.subscribe(
					(data: any) => {
						this.roles = data;

						resolve(data);
					}, (error) => {
						// console.log(error);

						reject(error);
					}
				);
		});
	}

	searchUsers(params) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/term/' + params.term +
				'/page/' + params.pageNumber +
				'/size/' + params.pageSize;

			this.http
				.get(this.url)
				.subscribe(
					(data: any) => {
						resolve(data.Data);
					},
					err => { reject(err); }
				);
		});
	}

	getUser(id) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/' + id;

			this.http
				.get(this.url)
				.subscribe(
					(data: any) => {
						resolve(data.Data);
					},
					err => { reject(err); }
				);
		});
	}

	getUserByUserId() {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl;

			this.http
				.get(this.url)
				.subscribe(
					(data: any) => {
						resolve(data.Data);
					},
					err => { reject(err); }
				);
		});
	}

	createUser(params) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl;

			this.http
				.post(
					this.url,
					params
				)
				.subscribe(
					(data: any) => {
						resolve(data);
					},
					err => { reject(err); }
				);
		});
	}

	updateUser(params) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/' + params.Id;

			this.http
				.put(this.url, params)
				.subscribe(
					(data: any) => {
						resolve(data);
					},
					err => { reject(err); }
				);
		});
	}

	changePassword(newPassword) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/password';

			this.http
				.post(
					this.url,
					{ Password: newPassword }
				)
				.subscribe(
					(data: any) => {
						resolve(data);
					},
					err => { reject(err); }
				);
		});
	}

	uploadImage(params) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/file';

			this.http
				.post(
					this.url,
					params
				)
				.subscribe(
					(data: any) => {
						resolve(data.Data);
					},
					err => { reject(err); }
				);
		});
	}

	updateEmail(params: any) {
		return new Promise((resolve, reject) => {
			this.url = `${this.globals.dataUrl}${this.baseUrl}/email`;

			this.http
				.put(this.url, params)
				.subscribe(
					(data: any) => {
						resolve(data);
					},
					err => { reject(err); }
				);
		});
	}
}
